import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'header' | 'cta';
  size?: 'normal' | 'large';
  href?: string;
}
export function Button({
  variant = 'cta',
  size = 'normal',
  className,
  href,
  children,
  ...props
}: ButtonProps) {
  const isExternal = !!href && /^https?:\/\//.test(href);
  const baseStyles = 'inline-block font-display font-black rounded-lg uppercase text-center transition-all duration-200 border-none cursor-pointer';
  const variants = {
    header: 'bg-mc-yellow text-mc-dark text-xs py-2.5 px-5 tracking-wide whitespace-nowrap hover:bg-mc-yellowHover hover:-translate-y-[1px]',
    cta: 'bg-mc-yellow text-mc-dark text-base py-4 px-8 tracking-wide hover:bg-mc-yellowHover hover:-translate-y-[2px] hover:shadow-glow w-full max-w-[420px]'
  };
  const sizes = {
    normal: '',
    large: 'text-lg py-5 px-10'
  };
  const classes = twMerge(baseStyles, variants[variant], variant === 'cta' && sizes[size], className);
  const MotionTag = motion.button;
  if (href) {
    return <motion.a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={classes} whileTap={{
      scale: 0.98
    }} data-id="element-188">
        {children}
      </motion.a>;
  }
  return <MotionTag className={classes} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-189">
      {children}
    </MotionTag>;
}